import { Badge } from "@/components/ui/badge";
import {
  type ForeclosureCaseReviewStatus,
  foreclosureCaseReviewStatusBadgeVariant,
  formatForeclosureCaseReviewStatus,
} from "@/lib/foreclosure-case-review-status";
import { cn } from "@/lib/utils";

interface ForeclosureCaseReviewStatusBadgeProps {
  status: ForeclosureCaseReviewStatus | null | undefined;
  className?: string;
  /** Prefix shown before the status label (e.g. "Review status"). */
  labelPrefix?: string;
}

/** Visible review-status chip for foreclosure case review surfaces. */
export function ForeclosureCaseReviewStatusBadge({
  status,
  className,
  labelPrefix,
}: ForeclosureCaseReviewStatusBadgeProps) {
  const label = formatForeclosureCaseReviewStatus(status);
  return (
    <Badge
      variant={foreclosureCaseReviewStatusBadgeVariant(status)}
      className={cn("max-w-full truncate", className)}
      title={labelPrefix ? `${labelPrefix}: ${label}` : label}
    >
      {labelPrefix ? `${labelPrefix}: ${label}` : label}
    </Badge>
  );
}
